import { css } from '@/styled-system/css';

export const verticalNavDividerStyles = css.raw({
  marginBlock: 'loose',
});
